import React from 'react';
import { render } from 'react-dom';
import { getJsonDataFromDataAttribute } from '~utils/json';
import TimeCalendar, { timeCalendarConfigSchema } from '~react/components/TimeCalendar';

const DATA_ATTRIBUTE = 'data-time-calendar';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[${DATA_ATTRIBUTE}]`).forEach(app => {
        const config = timeCalendarConfigSchema.parse(getJsonDataFromDataAttribute(app.getAttribute(DATA_ATTRIBUTE)));

        render(<TimeCalendar config={config} />, app);
    });
});
